module.exports = __webpack_public_path__ + "images/326d93f90af3e7ccbfd548493b27b1b0-IMG_7698.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_7698.jpg
// module id = ./src/assets/images/slides/living2/IMG_7698.jpg
// module chunks = 0